// クラシック版の右の列のボタンの並び（段階 C の2 の 5b。2026-10-25 に chibi.js と画面ファイル gen1a.js・gen1b.js・gen2.js の setNewMakeManu から描き直した。並び・大きさは前と同じ）。
// 完成のボタン（浮いたボタン）・メインのメニュー（右端に縦に並ぶ）・調整のサブメニュー（最初は隠す）・メニューの一覧（名前・ランダム・TOP へ・閉じる）・
// 移動の矢印（系統のある画面だけ）を置く。並べるのは charat.common.makeFloatButton・makeMenuButton（セーブスロットの slots.js が makeFloatButton を包むので、名前で呼ぶ）。
// 系統（SCREEN）ごとの違い:
//   エンジンのまま: メインは 1 段目が isMenu なら編集メニュー・無ければ復元、色・柄・移動。テスト環境は 5 段目に編集メニュー。サブは移動なし。矢印なし
//   第1世代 a: メインは編集メニュー・色・調整・左右。メニューの一覧の名前のボタンは MENU_NAME_BUTTON
//   第1世代 b: ボタンの大きさの基準が PC で 10.5、完成は丸（SAVE_BTN_LARGE で大きく）、メインに パーツ、サブは 8 等分（線の太さの無いメーカーは 1 段下げる）、矢印の置き方が違う
//   第2世代: メインは編集メニュー・色・柄・調整・左右、サブは SUBMENU_DIV 等分で線の太さ（STROKE_WIDTH）、メニューの一覧の名前のボタンは NAME_INPUT
import type { Category } from '../types.js';
import { chibi, common } from './engine.js';
import { bindData, onClick, setAttr, setXlinkHref, svgEl } from './dom.js';
import { screen } from './colors.js';
import * as fx from './fx.js';
import type { Selection } from './selection.js';

interface Scale {
  (v: number): number;
}
interface MenuEngine {
  isMobile: boolean;
  isTest: boolean;
  DIV_F_MAKEMENU: string;
  ATTR_EDITFLOATBUTTON: string;
  ATTR_EDITMENUBUTTON: string;
  ATTR_EDITSUBBUTTON: string;
  ATTR_EDITLISTBUTTON: string;
  ATTR_MOVEBUTTON: string;
  ATTR_LAYER: string;
  COLOR_NONACTIVE: string;
  COLOR_ACTIVE: string;
  PATH_IMG: string;
  SVG_FILE_KEY: string;
  SIZE_CHARAT_IMAGE: number;
  svgMakeMenu: Selection;
  svgEditMenu: Selection;
  svgMake: Selection;
  selCategory: Category;
  scMake: { x: Scale; y: Scale };
  config<T>(key: string, def: T): T;
  btnSubMove: { OFF(): void };
  [name: string]: unknown;
}
const E = (): MenuEngine => chibi() as unknown as MenuEngine;
type Common = {
  makeFloatButton(list: unknown): void;
  makeMenuButton(list: unknown): void;
  moveG(svg: Selection, cat: Category, key: string, mvx: number, mvy: number, a: number, b: number, c: number, d: number, sx: Scale, sy: Scale, size: number): void;
};
const C = (): Common => common() as unknown as Common;

/** 右の列のボタンを並べる */
export function setNewMakeManu(): void {
  const e = E(), scr = screen();
  const gen1a = scr === 'gen1a', gen1b = scr === 'gen1b', gen2 = scr === 'gen2', isNew = scr === 'new';
  const btn = (name: string): unknown => e[name];
  const NA = e.COLOR_NONACTIVE, AC = e.COLOR_ACTIVE;
  const menuW = Number(e.svgMakeMenu.attr('width'));
  const menuH = Number(e.svgMakeMenu.attr('height'));
  const editW = Number(e.svgEditMenu.attr('width'));
  // ボタンの大きさの基準（メニューの幅をこの値で割る。スマホは大きめ）
  const btnScale = { W: e.isMobile ? 7.5 : gen1b ? 10.5 : 8.5, H: e.isMobile ? 1.5 : 2 };
  const icon = { W: menuW / btnScale.W, H: menuW / btnScale.W };
  // 右上の完成のボタン
  const large = gen1b && e.config('SAVE_BTN_LARGE', false);
  const floatbtn = {
    LAYER: e.svgMakeMenu,
    CLASS: e.ATTR_EDITFLOATBUTTON,
    VISIBLE: true,
    REAR: gen1b ? 'circle' : '',
    DATA: [
      large
        ? { BTN: btn('btnSaveChara'), POS: { X: menuW - icon.W * 1.65, Y: icon.H * 0.2 }, SIZE: { W: icon.W * 1.5, H: icon.H * 1.5 }, SCALE: 1.02, COLOR: [NA, NA] }
        : { BTN: btn('btnSaveChara'), POS: { X: menuW - icon.W * (gen1b ? 1.3 : 1), Y: icon.H * 0.3 }, SIZE: { W: icon.W, H: icon.H }, SCALE: 1.5, COLOR: [NA, NA] },
    ],
  };
  // メインのメニュー（右端に縦に並ぶボタン。TOP は上からの段）
  const btnMScale = { W: e.isMobile ? 5 : 6, H: e.isMobile ? 8 : 11 };
  const top = 2;
  const LR = [NA, AC, AC, AC];
  const mainList: [string, string[] | null][] = isNew
    ? [[typeof isMenu !== 'undefined' && isMenu ? 'btnEditMenu' : 'btnRestore', null], ['btnEditColor', null], ['btnEditPattern', null], ['btnSubMove', null]]
    : gen1a
      ? [['btnEditMenu', null], ['btnEditColor', null], ['btnEditSub', null], ['btnEditLR', LR]]
      : gen1b
        ? [['btnEditMenu', null], ['btnEditColor', null], ['btnEditParts', null], ['btnEditSub', null], ['btnEditLR', LR]]
        : [['btnEditMenu', null], ['btnEditColor', null], ['btnEditPattern', null], ['btnEditSub', null], ['btnEditLR', LR]];
  const mainbtn = {
    LAYER: e.svgMakeMenu,
    CLASS: e.ATTR_EDITMENUBUTTON,
    VISIBLE: true,
    SIZE: { W: menuW / btnMScale.W, H: menuW / btnMScale.H },
    STYLE: 'r',
    POS: 'r',
    SCALE: 0.6,
    DATA: mainList.map(([name, color], i) => ({ BTN: btn(name), TOP: top + [0, 1.1, 2.2, 3.3, 4.4][i], COLOR: color || [NA, AC] })),
  };
  // テスト環境（エンジンのまま）は 5 段目に編集メニュー（isMenu のときは 1 段目と同じボタンが 2 つになる。前と同じ）
  if (isNew && e.isTest) mainbtn.DATA.push({ BTN: btn('btnEditMenu'), TOP: top + 4.4, COLOR: [NA, AC] });
  // 調整のサブメニュー（最初は隠す。残りは空きのボタンで段を埋める）
  const stroke = e.config('STROKE_WIDTH', false);
  const subDiv = gen1b ? 8 : gen2 ? e.config('SUBMENU_DIV', 9) : 9;
  const subNames: string[] = isNew
    ? ['btnSubZoom', 'btnSubReverse', '', 'btnSubExpand', 'btnSubContract', 'btnEditDummy', 'btnEditDummy', 'btnEditDummy', 'btnEditDummy', 'btnEditDummy']
    : gen1a
      ? ['btnSubZoom', 'btnSubReverse', 'btnSubMove', 'btnSubExpand', 'btnSubContract', 'btnEditDummy', 'btnEditDummy', 'btnEditDummy', 'btnEditDummy', 'btnEditDummy']
      : gen1b
        ? stroke
          ? ['btnSubZoom', 'btnSubReverse', 'btnSubMove', 'btnSubExpand', 'btnSubContract', 'btnSubThick', 'btnSubThin', 'btnEditDummy']
          : ['btnEditDummy', 'btnSubZoom', 'btnSubReverse', 'btnSubMove', 'btnSubExpand', 'btnSubContract', 'btnEditDummy', 'btnEditDummy']
        : ['btnSubZoom', 'btnSubReverse', 'btnSubMove', 'btnSubExpand', 'btnSubContract', stroke ? 'btnSubThick' : 'btnEditDummy', stroke ? 'btnSubThin' : 'btnEditDummy', 'btnEditDummy', 'btnEditDummy', 'btnEditDummy'];
  const subMenubtn = {
    LAYER: e.svgMakeMenu,
    CLASS: e.ATTR_EDITSUBBUTTON,
    VISIBLE: false,
    SIZE: { W: menuW / subDiv, H: Math.ceil(menuH / subDiv) },
    STYLE: 's',
    POS: 'ls',
    SCALE: 0.9,
    // 段（TOP）は並びの番号。エンジンのままは 2 段目（移動）が空く
    DATA: subNames.map((name, i) => (name ? { BTN: btn(name), TOP: i, COLOR: [NA, NA] } : null)).filter((d) => d !== null),
  };
  // メニューの一覧（左上のメニューのボタンで開く。項目のボタンと閉じるボタン）
  const mList = { W: menuW / btnScale.H, H: menuW / btnScale.W };
  const mExec = { W: menuW / (btnScale.H * 2), H: menuW / btnScale.W };
  const hasName = gen2 ? e.config('NAME_INPUT', true) : gen1a ? e.config('MENU_NAME_BUTTON', true) : true;
  const rows = [2, 3.2, 4.4, 5.6];
  const items = (hasName ? ['btnMenuName', 'btnMenuRandom', 'btnMenuTop'] : ['btnMenuRandom', 'btnMenuTop']).map((name, i) => ({
    BTN: btn(name),
    POS: { X: (editW - mList.W) / 2, Y: mList.H * rows[i] },
    SIZE: { W: mList.W, H: mList.H },
    COLOR: [] as string[],
  }));
  items.push({ BTN: btn('btnMenuClose'), POS: { X: (editW - mExec.W) / 2, Y: mExec.H * rows[items.length] }, SIZE: { W: mExec.W, H: mExec.H }, COLOR: [] });
  const editMenubtn = { LAYER: e.svgEditMenu, CLASS: e.ATTR_EDITLISTBUTTON, VISIBLE: true, DATA: items };
  const c = C();
  c.makeFloatButton(floatbtn);
  c.makeMenuButton(mainbtn);
  c.makeMenuButton(subMenubtn);
  // テスト環境はヘルプのボタン（復元コード）を閉じるボタンの所に入れ、閉じるボタンを 1 段下げる
  // （第2世代は名前のボタンが無ければ 1 段上に。第1世代 a で名前のボタンが無いときは 4 番目＝ヘルプ自身を下げる。前と同じ）
  if (e.isTest) {
    const helpRow = gen2 && !hasName ? 4.4 : 5.6;
    items.push({ BTN: btn('btnMenuHelp'), POS: { X: (editW - mList.W) / 2, Y: mList.H * helpRow }, SIZE: { W: mList.W, H: mList.H }, COLOR: [] });
    if (gen2 && !hasName) items[2].POS.Y = mList.H * 5.6;
    else items[3].POS.Y = mList.H * 6.8;
  }
  c.makeFloatButton(editMenubtn);
  // 移動の矢印（系統のある画面だけ。エンジンのままは位置を計算するだけで置いていなかった）
  if (!isNew) {
    moveButtons(gen1b);
    e.btnSubMove.OFF();
  }
}

/** キャラの上に出す移動の矢印（上・右・下・左。押すと選んでいるカテゴリを 1 つ動かす） */
function moveButtons(gen1b: boolean): void {
  const e = E();
  const layer = e.svgMakeMenu.node();
  if (!layer) return;
  const w = fx.width(e.DIV_F_MAKEMENU), h = fx.height(e.DIV_F_MAKEMENU);
  const img = e.PATH_IMG + 'switch/bt_move.svg' + e.SVG_FILE_KEY;
  let mW: number;
  let pos: { X: number; Y: number; R: number }[];
  if (gen1b) {
    const cx = w / 2, cy = h / 2, f = h / 4, d = e.isMobile ? 1.7 : 1.2;
    mW = f;
    pos = [
      { X: cx - f / 2, Y: f / 3, R: 0 },
      { X: cx * 2 - f - f / d, Y: cy - f / 2, R: 90 },
      { X: cx - f / 2, Y: cy * 2 - f - f / 3, R: 180 },
      { X: f / d, Y: cy - f / 2, R: 270 },
    ];
  } else {
    const cx = w / 2, cy = h / 2, xwpos = e.isMobile ? 1.7 : 1.2;
    mW = Math.min(w / 4, h / 4);
    const ymiddle = cy - mW / 2;
    pos = [
      { X: cx - mW / 2, Y: ymiddle - mW, R: 0 },
      { X: cx * 2 - mW - mW / xwpos, Y: ymiddle, R: 90 },
      { X: cx - mW / 2, Y: ymiddle + mW, R: 180 },
      { X: mW / xwpos, Y: ymiddle, R: 270 },
    ];
  }
  pos.forEach((p, i) => {
    const d = { IMG: img, ...p };
    const g = svgEl('g', { class: e.ATTR_MOVEBUTTON });
    bindData(g, d);
    const im = svgEl('image');
    setXlinkHref(im, d.IMG);
    setAttr(im, 'x', d.X);
    setAttr(im, 'y', d.Y);
    setAttr(im, 'width', mW);
    setAttr(im, 'height', mW);
    setAttr(im, 'transform', 'rotate(' + d.R + ',' + (d.X + mW / 2) + ',' + (d.Y + mW / 2) + ')');
    bindData(im, d);
    onClick(im, (ev) => {
      ev.stopPropagation();
      const en = E();
      const mvx = i == 1 ? 1 : i == 3 ? -1 : 0;
      const mvy = i == 0 ? -1 : i == 2 ? 1 : 0;
      if ((en.selCategory.IS_MOVE == 1 && mvy != 0) || (en.selCategory.IS_MOVE == 3 && (mvx != 0 || mvy != 0))) {
        C().moveG(en.svgMake, en.selCategory, en.ATTR_LAYER, mvx, mvy, 0, 0, 0, 0, en.scMake.x, en.scMake.y, en.SIZE_CHARAT_IMAGE);
      }
    });
    g.appendChild(im);
    layer.appendChild(g);
  });
}
